<template>
  <div>
    <v-row>
      <v-col cols="11"
        ><v-text-field :label="label" v-model="model"></v-text-field
      ></v-col>
      <v-col cols="1">
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              v-if="model"
              icon
              @click="followLink()"
              ><v-icon>mdi-link</v-icon></v-btn
            >
          </template>
          <span>Follow {{ model }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "LinkInput",
  components: {},
  props: {
    formModel: [Object, Array],
    parentModel: [Object, Array],
    parentKey: String,
    parModel: Object,
    label: String,
    on: Object,
    vModel: Object,
    vBind: Object,
    required: [Boolean, String],
    rules: Array,
    k: String,
  },
  data() {
    return {
      model: "",
    };
  },
  mounted() {
    if (this.vModel && this.vModel.length) {
      this.model = this.vModel;
    }
  },
  beforeDestroy() {},
  methods: {
    followLink() {
      window.open(this.vModel);
    },
  },
  watch: {
    model() {
      this.$emit("input", this.model);
    },
  },
};
</script>

<style lang="css" scoped></style>
